import React, { useEffect, useRef, useState } from "react";
import { Form, List, Message } from "semantic-ui-react";
import Input from "./Input";
import {
  getPasswordValidationDetails,
  PASSWORD_VALIDATION_RULES,
} from "../../helpers/password";

const ChangePasswordForm = ({
  password,
  newPassword,
  confirmPassword,
  setPassword,
  setNewPassword,
  setConfirmPassword,
  onSubmit,
  hideCurrentPassword = false,
  customMessage = null,
  userFullName = null,
}) => {
  const [passwordVisible] = useState(!password && !hideCurrentPassword);
  const currentPasswordRef = useRef();
  const newPasswordRef = useRef();

  useEffect(() => {
    if (passwordVisible && currentPasswordRef.current) {
      currentPasswordRef.current.focus();
    } else if (newPasswordRef.current) {
      newPasswordRef.current.focus();
    }
  }, [passwordVisible]);

  const [passwordValidation, setPasswordValidation] = useState({
    passwordLength: false,
    hasUppercase: false,
    hasLowercase: false,
    hasSpecialCharacters: false,
    hasNumber: false,
  });

  const handlePasswordValidation = (_, { value }) => {
    setNewPassword(value);
    setPasswordValidation(getPasswordValidationDetails(value));
  };

  return (
    <Form>
      {customMessage ? (
        <Message info>
          {userFullName && (
            <Message.Header>Welcome, {userFullName}!</Message.Header>
          )}
          <p>{customMessage}</p>
        </Message>
      ) : (
        <p style={{ marginTop: 0 }}>You need to change your password.</p>
      )}

      {!hideCurrentPassword && (
        <Input
          label="Current Password"
          type="password"
          name="password"
          value={password}
          visible={passwordVisible}
          ref={currentPasswordRef}
          onChange={(_, { value }) => setPassword(value)}
          onSubmit={onSubmit}
        />
      )}

      <Input
        label="New Password"
        type="password"
        name="newPassword"
        value={newPassword}
        ref={newPasswordRef}
        onChange={handlePasswordValidation}
        onSubmit={onSubmit}
      />
      <Input
        label="Confirm New Password"
        type="password"
        name="confirmPassword"
        value={confirmPassword}
        onChange={(_, { value }) => setConfirmPassword(value)}
        onSubmit={onSubmit}
      />
      {newPassword.length > 0 && (
        <List>
          <List.Item
            className={
              passwordValidation[PASSWORD_VALIDATION_RULES.length.key]
                ? " passwordItem--right"
                : " passwordItem--wrong"
            }
          >
            <List.Icon
              name={
                passwordValidation[PASSWORD_VALIDATION_RULES.length.key]
                  ? "check"
                  : "times"
              }
            />
            <List.Content>{PASSWORD_VALIDATION_RULES.length.text}</List.Content>
          </List.Item>
          <List.Item
            className={
              passwordValidation[PASSWORD_VALIDATION_RULES.uppercase.key]
                ? " passwordItem--right"
                : " passwordItem--wrong"
            }
          >
            <List.Icon
              name={
                passwordValidation[PASSWORD_VALIDATION_RULES.uppercase.key]
                  ? "check"
                  : "times"
              }
            />
            <List.Content>
              {PASSWORD_VALIDATION_RULES.uppercase.text}
            </List.Content>
          </List.Item>
          <List.Item
            className={
              passwordValidation[PASSWORD_VALIDATION_RULES.lowercase.key]
                ? " passwordItem--right"
                : " passwordItem--wrong"
            }
          >
            <List.Icon
              name={
                passwordValidation[PASSWORD_VALIDATION_RULES.lowercase.key]
                  ? "check"
                  : "times"
              }
            />
            <List.Content>
              {PASSWORD_VALIDATION_RULES.lowercase.text}
            </List.Content>
          </List.Item>
          <List.Item
            className={
              passwordValidation[PASSWORD_VALIDATION_RULES.specialChar.key]
                ? " passwordItem--right"
                : " passwordItem--wrong"
            }
          >
            <List.Icon
              name={
                passwordValidation[PASSWORD_VALIDATION_RULES.specialChar.key]
                  ? "check"
                  : "times"
              }
            />
            <List.Content>
              {PASSWORD_VALIDATION_RULES.specialChar.text}
            </List.Content>
          </List.Item>
          <List.Item
            className={
              passwordValidation[PASSWORD_VALIDATION_RULES.number.key]
                ? " passwordItem--right"
                : " passwordItem--wrong"
            }
          >
            <List.Icon
              name={
                passwordValidation[PASSWORD_VALIDATION_RULES.number.key]
                  ? "check"
                  : "times"
              }
            />
            <List.Content>{PASSWORD_VALIDATION_RULES.number.text}</List.Content>
          </List.Item>
          {confirmPassword.length > 0 && (
            <List.Item
              className={
                newPassword === confirmPassword
                  ? " passwordItem--right"
                  : " passwordItem--wrong"
              }
            >
              <List.Icon
                name={newPassword === confirmPassword ? "check" : "times"}
              />
              <List.Content>Passwords should match</List.Content>
            </List.Item>
          )}
          {!hideCurrentPassword && password === newPassword && (
            <List.Item className={" passwordItem--wrong"}>
              <List.Icon name={"times"} />
              <List.Content>
                New password should be different from the previous one
              </List.Content>
            </List.Item>
          )}
        </List>
      )}
    </Form>
  );
};

export default ChangePasswordForm;
